import { myConst, myFn } from "@/config/";

const { $$ } = myFn;


export const loadingEnd = () => {
    setTimeout(() => {
        $$("#loading").on(myConst.animationEvent, () => {
            $$("#loading").remove();
        });
        $$("#loading").addClass("over");
        $$("body").addClass("enter");
    }, 1);
};



export const toggleFullScreen = function (on_off) {
    if (typeof on_off == 'boolean') {
        if (on_off) {
            enterFull();
        } else {
            exitFull();

        }
    } else {
        if (!document.fullscreenElement && // alternative standard method
            !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) { // current working methods
            enterFull();
        } else {
            exitFull();
        }
    }

    function enterFull() {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
        }
    }

    function exitFull() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

};
